import React from 'react';
import { Users, GraduationCap, HeartPulse, Target } from 'lucide-react';
export function ImpactSection() {
  const focusAreas = [{
    icon: <Users size={28} data-id="element-201" />,
    title: 'Community Empowerment',
    description: 'Transforming lives through sustainable development initiatives',
    color: 'bg-sfrr-green text-sfrr-green'
  }, {
    icon: <GraduationCap size={28} data-id="element-202" />,
    title: 'Education Support',
    description: 'Expanding access to quality education for underprivileged children',
    color: 'bg-sfrr-pink text-sfrr-pink'
  }, {
    icon: <HeartPulse size={28} data-id="element-203" />,
    title: 'Healthcare Access',
    description: 'Providing essential healthcare services to underserved communities',
    color: 'bg-sfrr-blue text-sfrr-blue'
  }, {
    icon: <Target size={28} data-id="element-204" />,
    title: 'Economic Opportunity',
    description: 'Creating pathways from vulnerability to dignity and self-reliance',
    color: 'bg-sfrr-yellow text-sfrr-yellow'
  }];
  return <section className="py-24 relative overflow-hidden" data-id="element-205">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-206">
        <div className="absolute inset-0 bg-warm-ivory/90 z-10" data-id="element-207"></div>
        <img src="https://cdn.magicpatterns.com/uploads/i1cBu4SCd9zBRRuRA5DHDj/e6d6e1d0-61b9-4bb2-8f61-d60c70afaa57.jpg" alt="Community development work" className="w-full h-full object-cover opacity-30" data-id="element-208" />
      </div>

      <div className="container mx-auto px-4 relative z-20" data-id="element-209">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-210">
          <h2 className="text-4xl md:text-5xl font-bold text-charcoal mb-6" data-id="element-211">
            Our Mission & Focus Areas
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed font-light" data-id="element-212">
            The Senator Fatimat Raji Rasaki Foundation is dedicated to uplifting
            the underprivileged across Nigeria. We focus on sustainable
            initiatives that transform beneficiaries from vulnerability to
            dignity and self-reliance.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-213">
          {focusAreas.map((area, index) => <div key={index} className="bg-white/90 backdrop-blur-sm p-8 rounded-2xl shadow-soft hover:shadow-hover transition-all duration-300 border border-white/50 animate-fadeInUp" style={{
          animationDelay: `${index * 100}ms`
        }} data-id="element-214">
              <div className={`w-14 h-14 rounded-full flex items-center justify-center mb-6 ${area.color} bg-opacity-10`} data-id="element-215">
                <div className={area.color.replace('bg-', 'text-')} data-id="element-216">
                  {area.icon}
                </div>
              </div>
              <h3 className="text-xl font-bold text-charcoal mb-3" data-id="element-217">
                {area.title}
              </h3>
              <p className="text-gray-600 font-light leading-relaxed" data-id="element-218">
                {area.description}
              </p>
            </div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-219">
          <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-8 max-w-2xl mx-auto shadow-soft" data-id="element-220">
            <p className="text-lg text-charcoal font-medium mb-4" data-id="element-221">
              Founded by Senator Fatimat Raji Rasaki
            </p>
            <p className="text-gray-600 leading-relaxed" data-id="element-222">
              At 70 years (January 13, 2026), Senator Fatimat dedicates her next
              chapter to structured service, building on decades of commitment
              to uplifting communities across Nigeria.
            </p>
          </div>
        </div>
      </div>
    </section>;
}